import type { FC } from 'react'
import { HBox } from '../layout/horizontal-box.js'
import { PulseProgress } from './pulse.js'
import type { PulseProps } from './pulse.js'

export interface PulseProgressBoxProps extends PulseProps {
  title?: string
}

export const PulseProgressBox: FC<PulseProgressBoxProps> = props => {
  const { title } = props
  return (
    <HBox style={{ flex: 1, alignItems: 'center', justifyContent: 'center', flexDirection: 'column' as const }}>
      <PulseProgress {...props} />
      {title ? (
        <span style={{
          marginTop: 8,
          fontSize: 'var(--tuna-typography-caption-fontSize)',
          color: 'var(--tuna-palette-text-secondary)',
        }}>
          {title}
        </span>
      ) : null}
    </HBox>
  )
}

export default PulseProgressBox
